import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";


const Main = lazy(() => import("../components/nomination/endorsement/endorsementDetails"));

const EndorsementDetails = () => {
  return (

      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>

  );
};

export default EndorsementDetails;
